var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2501,
    height: 2501,
    viewBox: "0 0 2501 2501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1250.5,
    cy: 1250.5,
    r: 954.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2500.51 1250.51C2500.51 1940.86 1940.86 2500.51 1250.51 2500.51C560.152 2500.51 0.507812 1940.86 0.507812 1250.51C0.507812 560.154 560.152 0.509766 1250.51 0.509766C1940.86 0.509766 2500.51 560.154 2500.51 1250.51ZM1630.92 1245.23C1653.37 1206.35 1709.5 1206.35 1731.96 1245.23L1971.68 1660.45C1994.13 1699.34 1966.07 1747.95 1921.16 1747.95H1441.71C1396.81 1747.95 1368.74 1699.34 1391.2 1660.45L1630.92 1245.23ZM1501.32 845.734C1523.65 884.41 1523.65 932.059 1501.32 970.735L1088.69 1685.44C1066.36 1724.12 1025.09 1747.94 980.435 1747.94H579.875C534.97 1747.94 506.905 1699.33 529.357 1660.44L1200.01 498.84C1222.46 459.952 1278.59 459.952 1301.04 498.84L1501.32 845.734Z",
    fill: "#FF394A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.ce1a85dda656e91737278c3393cb79c3.svg";
export { ForwardRef as ReactComponent };